import styles from "./detail-section-fields.module.scss";
import type { DetailSectionFieldsProps } from "./types-detail-section-fields";

/** Campos da seção: em duas colunas (`grade`, coluna única nas larguras menores) ou um por linha (`linha`). */
export function DetailSectionFieldsView({
  testId,
  variant = "grade",
  children,
}: DetailSectionFieldsProps) {
  return (
    <dl className={styles[variant]} data-testid={testId}>
      {children}
    </dl>
  );
}
